export const validatePeriod = (_rule, value, callback) => {
  if (!Array.isArray(value) || !value[0] || !value[1]) {
    callback('Выберите месяц');
    return;
  }

  callback();
};

export const getSelectedFirstOptions = (options = [], selectedValues = []) => {
  const normalizedSelectedValues = Array.isArray(selectedValues)
    ? selectedValues
    : [selectedValues].filter(Boolean);
  const selectedValueSet = new Set(normalizedSelectedValues.map(String));

  if (!selectedValueSet.size) {
    return options;
  }

  return options
    .map((option, index) => ({ option, index }))
    .sort((first, second) => {
      const firstSelected = selectedValueSet.has(String(first.option.value));
      const secondSelected = selectedValueSet.has(String(second.option.value));

      if (firstSelected === secondSelected) {
        return first.index - second.index;
      }

      return firstSelected ? -1 : 1;
    })
    .map(({ option }) => option);
};

export const getOptionText = (option = {}) =>
  option.text || option.content || option.label || option.value;

export const getOptionSearch = (option = {}) =>
  String(option.search || option.text || option.label || option.value || '');

export const filterSelectOption = (searchValue, option) =>
  String(option.props.search || '')
    .toLowerCase()
    .includes(String(searchValue || '').toLowerCase());

export const isDefinedValue = (value) => value !== undefined && value !== null;

export const getOptionByValueMap = (options = []) =>
  new Map(options.map((option) => [String(option.value), option]));

export const getPreviewKey = (prefix, value, index) =>
  `${prefix}-${value ?? index}`;
